import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-content-message',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './message.content.design.html',
    styleUrls: ['./message.content.design.scss'],
    standalone: false
})
export class MessageContentDesign {
  @Input() severity: FlatModels.TagDesignModels.Severity = FlatModels.TagDesignModels.Severity.enum.info;
  @Input({ required: true }) text!: string;
}
